<template>
  <v-main>
    <MasterDetail baseRoute="/setup/technicians">
      <!-- Lista de objetos -->
      <template v-slot:list="{ state, selectedId, selectRow }">
        <List
          class="maxh-full-2"
          :state="state"
          :focusRowId="selectedId"
          @rowSelected="(v) => selectRow(v)"
        />
      </template>

      <!-- Detalhe do selecionado -->
      <template v-slot:detail="{ selectedId, selectRow }">
        <div v-if="selectedId != null">
          <Home :techId="selectedId" @close="selectRow(null)" />
        </div>
      </template>
    </MasterDetail>
  </v-main>
</template>

<script>
import MasterDetail from 'oderon-vue/cpts/MasterDetail.vue'
import List from './List.vue'
import Home from './Home.vue'

export default {
  components: {
    List,
    Home,
    MasterDetail
  }
}
</script>

<style></style>
